import React from 'react';

const Modal = ({ isOpen, onClose, title, children, width = "55%" }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    // Only close if clicking the backdrop, not the modal content
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 p-4 overflow-y-auto"
      onClick={handleBackdropClick}
      style={{ fontFamily: 'Rubik, sans-serif', zIndex: 1100 }}
    >
      <div
        className="min-h-screen flex items-center justify-center py-4"
      >
        <div
          className="bg-white rounded-lg shadow-xl my-8"
          style={{ 
            width, 
            maxWidth: "1000px",
            maxHeight: "calc(100vh - 4rem)"
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center rounded-t-lg">
            <h2 style={{ 
              fontFamily: 'Rubik, sans-serif',
              fontSize: '23px', 
              fontWeight: 500, 
              color: '#333',
              margin: 0
            }}>
              {title}
            </h2>
            <button
              onClick={onClose}
              style={{
                fontSize: '36px',
                fontWeight: 300,
                color: '#470172',
                lineHeight: 1,
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                padding: 0,
                flexShrink: 0
              }}
              className="hover:opacity-70 transition-opacity"
              aria-label="Close modal"
            >
              ×
            </button>
          </div>
          <div className="px-6 py-4 overflow-y-auto" style={{ fontSize: '16px', maxHeight: 'calc(100vh - 12rem)' }}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
